import { Directive, ElementRef, HostListener, Inject } from '@angular/core';
import { DropdownLinkDirective } from './dropdown-link.directive';
import { LayoutService } from '../services/layout.service';

@Directive({
  selector: '[appDropdownToggle]'
})
export class DropdownAnchorDirective {

  protected navlink: DropdownLinkDirective;
  
    constructor(
      @Inject(DropdownLinkDirective) navlink: DropdownLinkDirective,
      private el: ElementRef<HTMLElement>,
      private layout: LayoutService,
    ) {
      this.navlink = navlink;
    }
  
    @HostListener('click', ['$event'])
    onClick(e: any) {
      // No modo compact: se o item tem submenu, expande sidebar ao clicar no pai
      // (mantém comportamento antigo de "abrir para escolher subopção", mas sem hover).
      const sidebarStyle = this.layout?.layoutConf?.sidebarStyle;
      if (sidebarStyle === 'compact' || sidebarStyle === 'compact-big') {
        const host = this.el?.nativeElement;
        const li = host?.closest('li');
        const hasSubmenu = !!li?.querySelector('ul.submenu');
        if (hasSubmenu) {
          this.layout.publishLayoutChange({ sidebarStyle: 'full' }, { transitionClass: true });
        }
      }

      this.navlink.toggle();
    }
}
